import React, { CSSProperties, ReactNode } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
// import {A, usePath} from 'hookrouter';
import styled from 'styled-components';

import { commonLinkStyle, CommonLinkProps } from './common.style';

const StyledNavLink = styled(NavLink)<CommonLinkProps>`
  ${commonLinkStyle}
`;

type Props = Omit<CommonLinkProps, '$underline'> & {
  to?: NavLinkProps['to'];
  isActive?: boolean;
  style?: CSSProperties;
  className?: string;
  end?: boolean;
  children: ReactNode;
  underline?: boolean;
};

function RouterNavLink({
  to = '',
  isActive: isActiveOverride,
  children,
  className,
  underline,
  // style,
  ...rest
}: Props) {
  return (
    <StyledNavLink
      onClick={to ? undefined : event => event.preventDefault()}
      to={to}
      {...rest}
      className={(isActiveOverride ? 'active ' : '') + className}
      $underline={underline}
    >
      {children}
    </StyledNavLink>
  );
}

export default RouterNavLink;
